import React from "react";
import { formatResponse } from "../../../helpers/common";
import Select from "react-select";
import { convertToNumber } from "../../../helpers/validations";


const NiceToHaveSelect = (props) => {
    const {
        selectedNiceToHave,
        handleFormValues,
        tab,
        placeholder,
        niceToHavesList,
        propertyType,
        componentValue,
        selectedniceToHavesList
    } = props;

    const handleNiceHaveChange = (e, tab) => {
        if (Array.isArray(e)) {
            var MaxCount = convertToNumber(propertyType) == 6 ? 10 : 16;
            var totalCount = convertToNumber(selectedniceToHavesList.length);
          
            let value = (e.map((opt) => {
                return { ...opt, tab: tab }
            }));

            let selectedValues = selectedniceToHavesList;
            let newvalue = [...selectedValues, ...value];
            var valueAfterClean = newvalue.filter((newvalue, index, self) =>
                index === self.findIndex((t) => (t.tab === newvalue.tab && t.value === newvalue.value)))

            let currentTabSelectedValues = valueAfterClean.filter((elem) => (elem.tab == tab));

            let newValueAddedArray = [];
            let removedArray = [];
      
            currentTabSelectedValues.map((i, index) => {
                if (value.find(d2 => d2.value == i.value)) {
                    if (currentTabSelectedValues.length == index + 1) {
                        let value = {
                            ...i,
                            id: i.value
                        }
                        newValueAddedArray = {
                            ...value, order: selectedniceToHavesList.length + 1
                        }
                    }
                } else {
          
                    let newArray = selectedniceToHavesList.filter((elem) => elem.value != i.value || elem.tab != i.tab);
                    newArray = newArray.filter((elem) => (elem))
            
                    removedArray = newArray.length > 0 ? newArray.map((opt, inex) => { return { ...opt, order: inex + 1 } }) : [];
             
                }
            });

            if (totalCount >= MaxCount) {
             
                if (removedArray.length > 0) {
                    handleFormValues({
                        nice2Have: removedArray,
                        focusOut: true
                    });
                } else {
                    let msg = "Selection Up to " + MaxCount + " items only";
                    alert(msg);
                }
            } else {
               
                handleFormValues({
                    // nice2Have: removedArray.length > 0 ? removedArray : [...selectedniceToHavesList, newValueAddedArray]
                    nice2Have: removedArray.length > 0 ? removedArray : (selectedniceToHavesList.length == 1  && newValueAddedArray.length == 0)   ?  [] : [...selectedniceToHavesList, newValueAddedArray] 
                    , focusOut: true
                });
            }
        }
    }


    /**
       * to set the selected option on load
       */
    const getOptionValue = (option, tab, mainList) => {
        if (option && mainList) {
            var selectedValue = option.filter(function (item) {
                if (item.tab == tab) {
                    return mainList.filter(function (nicetohave) {
                        if (nicetohave.value == item.id) {
                            item.value = nicetohave.value;
                            item.label = nicetohave.label;
                            return item;
                        }
                    })
                }
            })
            return selectedValue
        }
        return null;

    }

    return (
        <>
            <Select
                isMulti
                id="multi1"
                name="colors1"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(e) => { handleNiceHaveChange(e, tab) }}
                value={getOptionValue(selectedNiceToHave, tab, formatResponse(niceToHavesList))}
                placeholder={placeholder}
                options={formatResponse(niceToHavesList)}
                components={componentValue}
                className="basic-multi-select mb-4"
                classNamePrefix="select"
                isClearable={false}
            />
        </>
    );
};
export default NiceToHaveSelect;
